import { switchAnatomy as parts } from "../chakra/internal";
import { calc, cssVar } from "../chakra/internal";
const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');
const $diff = cssVar('switch-track-diff');
const diffValue = calc.subtract($width, $height);
const $translateX = cssVar('switch-thumb-x');
const baseStyleTrack = {
    borderRadius: 'full',
    p: 'spacing.xs',
    width: [
        $width.reference
    ],
    height: [
        $height.reference
    ],
    transitionProperty: 'common',
    transitionDuration: 'fast',
    bg: 'background.neutral.tertiary.default',
    _focus: {
        outline: `border.accent.primary.default solid 2px`,
        outlineOffset: '2px',
        boxShadow: 'none'
    },
    _disabled: {
        cursor: 'not-allowed'
    },
    _checked: {
        bg: 'background.accent.primary.default'
    }
};
const baseStyleThumb = {
    bg: 'white',
    transitionProperty: 'transform',
    transitionDuration: 'normal',
    borderRadius: 'inherit',
    width: [
        $height.reference
    ],
    height: [
        $height.reference
    ],
    _checked: {
        transform: `translateX(${$translateX.reference})`
    }
};
const baseStyle = {
    container: {
        [$diff.variable]: diffValue,
        [$translateX.variable]: $diff.reference,
        _rtl: {
            [$translateX.variable]: calc($diff).negate().toString()
        }
    },
    track: baseStyleTrack,
    thumb: baseStyleThumb
};
const sizes = {
    sm: {
        container: {
            [$width.variable]: '1.375rem',
            [$height.variable]: '0.75rem'
        }
    },
    md: {
        container: {
            [$width.variable]: '1.875rem',
            [$height.variable]: '1rem'
        }
    },
    lg: {
        container: {
            [$width.variable]: '2.875rem',
            [$height.variable]: '1.5rem'
        }
    }
};
const defaultProps = {
    size: 'md'
};
export const ThemedSwitch = {
    parts: parts.keys,
    baseStyle,
    sizes,
    defaultProps
};

//# sourceMappingURL=Switch.js.map